import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetCertificadosList = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/cuestionarios/list/${params.id}?parte=${params.parte}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getCertificadosListMutation: mutation.mutate,
    };
}